import {AccessRoleData} from "./access-role.data";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

/**
 * AccessRole LocalisableContextData is managed as a transient member on the data. The model handles
 * populating the LocalisableContextData on load and save.
 */
@Injectable()
export class AccessRoleEntityModel extends EntityModel<AccessRoleData> {

    constructor(injector: Injector) {
        super(injector, AccessRoleData);
    }
}
